import { useTranslations } from '@vocab/react';
import { Stack, Strong, Text, TextLink } from 'braid-design-system';
import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { CREDIT_HOLD_OUTSTANDING_INVOICES_PRESSED } from 'src/app/shared/dataAnalytics/schema/constants';
import getTrackingAdapter from 'src/app/v1/dataAnalytics';
import { useLocalisedRoutes } from 'src/app/v1/views/hooks/useLocalisedRoutes';
import type { AppState } from 'src/types/appState';

import translations from './.vocab';

const CreditHoldMessage = (props: {
  onHandleOutstandingClick: () => void;
  isAdmin: boolean;
}) => {
  const { t } = useTranslations(translations);
  const { generateInvoicePayableUrl } = useLocalisedRoutes();
  if (!props.isAdmin) {
    return <>{t('credit-hold-message-non-admin')}</>;
  }
  return (
    <>
      {t('credit-hold-message-admin', {
        Link: (children) => (
          <TextLink
            href={generateInvoicePayableUrl()}
            rel="noopener noreferrer"
            target="_blank"
            onClick={props.onHandleOutstandingClick}
          >
            {children}
          </TextLink>
        ),
      })}
    </>
  );
};

export const CreditHoldBody = () => {
  const { t } = useTranslations(translations);
  const selectedState = useSelector(
    ({ session: { userCanPayInvoices } }: AppState) => ({
      userCanPayInvoices,
    }),
    shallowEqual,
  );

  const onHandleOutstandingClick = () => {
    const eventData = {
      eventName: CREDIT_HOLD_OUTSTANDING_INVOICES_PRESSED,
      objectInteraction: 'credit-hold-outstanding-invoices',
    };
    getTrackingAdapter.sendLinkEvent(eventData);
  };

  return (
    <Stack space="medium">
      <Text>
        <Strong>{t('credit-hold-heading')}</Strong>
      </Text>
      <Text>
        <CreditHoldMessage
          onHandleOutstandingClick={onHandleOutstandingClick}
          isAdmin={selectedState.userCanPayInvoices}
        />
      </Text>
    </Stack>
  );
};
